import angular from 'angular';
import _ from 'lodash';

(function() {
    'use strict';
    angular.module('app.core').factory('InvoiceTemplate', InvoiceTemplateData);

    InvoiceTemplateData.$inject = ['InvoiceTemplateAttribute'];

    /* @ngInject */
    function InvoiceTemplateData(InvoiceTemplateAttribute) {
        InvoiceTemplate.prototype = {
            build: build,
            buildEmpty: buildEmpty,
            getAttByCategory: getAttByCategory,
            getAttBySection: getAttBySection,
            addAttributes: addAttributes
        };

        function InvoiceTemplate(invoiceTemplateData) {
            if (!invoiceTemplateData) {
                this.buildEmpty();
            } else {
                this.build(invoiceTemplateData);
            }
        }

        return InvoiceTemplate;

        /////////////////////

        function buildEmpty() {
            this.name = null;
            this.attributes = [];
        }

        function build(invoiceTemplateData) {
            this.name = invoiceTemplateData.name || null;
            this.attributes = _.map(_.orderBy(invoiceTemplateData.attributes, 'order'), function(a) {
                return new InvoiceTemplateAttribute(a);
            });
        }

        function getAttByCategory(category) {
            return _.filter(this.attributes, { category: category });
        }

        function getAttBySection(section) {
            return _.filter(this.attributes, { section: section });
        }

        function addAttributes(addedAttributes) {
            return _.orderBy(this.attributes.concat(addedAttributes), 'order');
        }
    }
})();
